<template>
  <div>
    <Spinner v-if="isLoading" />

    <div class="notification is-info" v-if="hasNoNotes">No notes found.</div>

    <button
      v-if="!isLoading"
      class="button is-success is-fullwidth is-outlined add-admin"
      @click="addNote()"
    >
      Add Note
    </button>

    <div class="notification is-danger" v-if="loadError">{{ loadError }}</div>

    <table class="table is-fullwidth is-striped" v-if="notesLoaded">
      <thead>
        <tr>
          <th></th>
          <th>Note</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="note in notes" :key="note.id">
          <td class="actions">
            <a @click="editNote(note)">
              <span>
                <i class="icon-edit-2"></i>
              </span>
            </a>
            <a @click="deleteNote(note)">
              <span>
                <i class="icon-trash-2 has-text-danger"></i>
              </span>
            </a>
          </td>
          <td>
            <div class="note-text">{{ note.note }}</div>

            <div class="note-caption">
              <span class="header">Added by</span>
              <span v-if="user(note.createdBy)">
                {{ user(note.createdBy).firstName }} {{ user(note.createdBy).lastName }}
              </span>
              <span v-else>{{ ' ...  ' }}</span>

              <span class="header">at</span>
              {{ note.createdAt }}
            </div>

            <div class="note-caption" v-if="note.createdAt !== note.updatedAt">
              <span class="header">Last updated by</span>
              <span v-if="user(note.updatedBy)">
                {{ user(note.updatedBy).firstName }} {{ user(note.updatedBy).lastName }}
              </span>
              <span v-else>{{ ' ...  ' }}</span>

              <span class="header">at</span>
              {{ note.updatedAt }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Modals -->
    <UserEditNoteModal
      v-if="noteToEdit != null"
      :userStorePath="userStorePath"
      :note="noteToEdit"
      @cancelled="closeEditNoteModal"
      @succeeded="closeEditNoteModal"
    />

    <UserDeleteNoteModal
      v-if="noteToDelete != null"
      :userStorePath="userStorePath"
      :note="noteToDelete"
      @cancelled="closeDeleteNoteModal"
      @succeeded="closeDeleteNoteModal"
    />
  </div>
</template>

<script>
import Spinner from '@/components/utils/Spinner'

import UserEditNoteModal from './UserEditNoteModal'
import UserDeleteNoteModal from './UserDeleteNoteModal'

import {
  LOAD_NOTES,
  IS_LOADING_NOTES,
  GET_NOTES,
  GET_NOTES_LOAD_ERROR,
  HAS_EMPTY_NOTES_LOAD_RESULT
} from './userStore'

import { LOAD_USERS_WITH_IDS, GET_USER_WITH_ID } from './usersCacheStore'

export default {
  name: 'UserNotesTab',

  components: {
    Spinner,
    UserEditNoteModal,
    UserDeleteNoteModal
  },

  props: {
    userStorePath: {
      type: String,
      required: true
    },

    usersCacheStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      noteToEdit: null,
      noteToDelete: null
    }
  },

  mounted() {
    const loadNotesAction = `${this.userStorePath}/${LOAD_NOTES}`
    this.$store.dispatch(loadNotesAction)

    this.loadUsers()
  },

  computed: {
    notesLoaded() {
      return this.notes !== null
    },

    isLoading() {
      const isLoadingNotes = `${this.userStorePath}/${IS_LOADING_NOTES}`
      return this.$store.getters[isLoadingNotes]
    },

    hasNoNotes() {
      const hasEmptyNotesLoadResult = `${this.userStorePath}/${HAS_EMPTY_NOTES_LOAD_RESULT}`
      return this.$store.getters[hasEmptyNotesLoadResult]
    },

    notes() {
      const notes = `${this.userStorePath}/${GET_NOTES}`
      return this.$store.getters[notes]
    },

    loadError() {
      const getNotesLoadError = `${this.userStorePath}/${GET_NOTES_LOAD_ERROR}`
      return this.$store.getters[getNotesLoadError]
    }
  },

  methods: {
    loadUsers() {
      if (!this.notes) {
        return
      }

      let userIds = this.notes.map(note => note.createdBy)
      userIds = [...userIds, ...this.notes.map(note => note.updatedBy)]

      const loadUsersAction = `${this.usersCacheStorePath}/${LOAD_USERS_WITH_IDS}`
      this.$store.dispatch(loadUsersAction, { userIds })
    },

    user(userId) {
      const getUserWithIdPath = `${this.usersCacheStorePath}/${GET_USER_WITH_ID}`
      return this.$store.getters[getUserWithIdPath](userId)
    },

    addNote() {
      this.noteToEdit = {
        id: null,
        note: null
      }
    },

    editNote(note) {
      this.noteToEdit = note
    },

    closeEditNoteModal() {
      this.noteToEdit = null
    },

    deleteNote(note) {
      this.noteToDelete = note
    },

    closeDeleteNoteModal() {
      this.noteToDelete = null
    }
  },

  watch: {
    notes() {
      this.loadUsers()
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  margin-top: 1em;

  td {
    border-bottom: 0;

    span {
      white-space: nowrap;
    }

    .note-text {
      margin-bottom: 0.5em;
      white-space: pre;
    }

    .button {
      padding: 0px;
      height: 1.5em;
    }
  }

  td.actions {
    width: 50px;

    a {
      margin-right: 0.5em;
    }
  }

  .note-caption {
    // margin-top: 0.5em;

    font-weight: bold;
    font-style: italic;
    color: rgb(124, 124, 124);
    font-size: 13px;

    .header {
      font-weight: normal !important;
    }
  }
}
</style>
